/* eslint-disable */ 
import credentialsMixin from "@/mixins/credentials-mixin"
import axios from "axios"
export default {
    data() {
        return {
            loginIncrementor : 0,
            authorizeUrl : "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
            tokenUrl : "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
            logoutUrl : "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8085/",
            scope : `${process.env.OAUTH_SCOPE}`,
            client_id: `${process.env.CLIENT_ID}`,
            redirect_uri: `${window.document.location.origin}`,///auth/pkce/callback`,
            resource:"",
            showDebugInfo : false,
            autoLogin : true,
            test: null
        }
    },
    mixins : [credentialsMixin],
    computed : {
        isLoggedIn()
        {
            return !!this.credentialInfo
        },
        credentialInfo()
        {
            
            return this.getCredentials(this.client_id);
        },
        requestHeaders()
        {
            // ;
            var returnValue = {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
                "Access-Control-Allow-Headers": "x-ms-*,content-*",
            };
            var isAzureDeployed =  `${process.env.AZURE_DEPLOYED}`;
            if(!!this.credentialInfo && isAzureDeployed==1)
            {
                returnValue["Authorization"] = `bearer ${this.credentialInfo.access_token}`;
            }
            return returnValue;
        },
        fileHeaders()
        {
            // ;
            var returnValue = {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
                "Access-Control-Allow-Headers": "x-ms-*,content-*",
                "Content-Type": "multipart/form-data"
            };
            var isAzureDeployed =  `${process.env.AZURE_DEPLOYED}`;
            if(!!this.credentialInfo && isAzureDeployed==1)
            {
                returnValue["Authorization"] = `bearer ${this.credentialInfo.access_token}`;
            }
            return returnValue;
        }
    },
    watch: {
        globalCredentialCache(newVal) {
             ;
            this.test = newVal;
        }
    },
    methods : {

        request(url, options)
        {
            var config = Object.assign({
                method: 'get',
                url: url,
                data: null,
                headers : this.requestHeaders,
                withCredentials: true,
            }, options);
            try
            {
                // 
                return axios(config);
            }
            catch(err)
            {
                console.error(err);
                throw err;
            }
        },
        getMyInfo()
        {
            //return await this.request(`${process.env.API_URL}/.auth/me`);
            return this.request("http://localhost:5489/api/log/Test");
        },
        getMyInfoPost()
        {
            return this.request(
                `${process.env.API_URL}/.auth/me`,{ method : "post",}
            );
        },
    }
}


// WEBPACK FOOTER //
// ./src/mixins/requests.js